import { HttpParams } from '@angular/common/http';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setParams = (filter: any): HttpParams => {
  let params = new HttpParams();
  for (const key in filter) {
    if (
      Object.prototype.hasOwnProperty.call(filter, key) &&
      filter[key] !== null &&
      filter[key] !== ''
    ) {
      params = params.append(key, filter[key]);
    }
  }
  return params;
};
